<div class="input-group action">
    <div class="input-group-btn btn-in-table">
        <button *ngIf="!(!data.isActive && !data.isInvited) && data.userType != 'resident'"
                (click)="onClick('edit')"
                class="btn btn-white btn-xs same-button-width">
            Edit
        </button>
        <button *ngIf="!data.isActive && !data.isInvited && data.userType != 'resident'"
                (click)="onClick('sendInvitation')"
                class="btn btn-white btn-xs same-button-width">
            Send Invitation
        </button>
        <button *ngIf="data.userType == 'resident' && canDelete"
                (click)="onClick('remove')"
                class="btn btn-white btn-xs same-button-width">
            Delete
        </button>
        <button *ngIf="data.userType == 'resident' && !canDelete && data.isActive"
                (click)="onClick('resetPassword')"
                class="btn btn-white btn-xs same-button-width">
            Reset Password
        </button>

        <button class="btn btn-white btn-xs action__btn" (click)="toggle()">
            <span class="caret"></span>
        </button>
        <ul [class.active]="isShow" class="action__dropdown-menu dropdown-menu pull-right">
            <li *ngIf="!data.isActive && !data.isInvited && data.userType != 'resident'"
                (click)="onClick('edit')">
                <a>Edit</a>
            </li>
            <li *ngIf="data.userType != 'resident' && canDelete" (click)="onClick('remove')">
                <a>Delete</a>
            </li>
            <li *ngIf="userType == 'super_admin'" (click)="onClick('history')">
                <a>View History</a>
            </li>
            <li *ngIf="!data.isActive && data.isInvited && data.userType != 'resident'"
                (click)="onClick('resendInvitation')">
                <a>Resend Invitation</a>
            </li>
            <li (click)="onClick('resetPassword')" *ngIf="data.isActive">
                <a>Reset Password</a>
            </li>
            <li *ngIf="accountPermissionsService.isUserAdmin() || accountPermissionsService.isUserCompanyAdmin()"
                (click)="onClick('toggleUserLock')">
                <a>{{ data.isLocked ? 'Unlock user' : 'Lock user' }}</a>
            </li>
            <li *ngIf="data.userType == 'resident'" (click)="onClick('editName')">
                <a>Edit Name</a>
            </li>
            <li *ngIf="data.userType == 'resident'" (click)="onClick('residentToStaff')">
                <a>Resident to Staff</a>
            </li>
            <li *ngIf="userType == 'super_admin' && data.isActive" (click)="onClick('loginAsUser')">
                <a>Log In As User</a>
            </li>
        </ul>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/admin/user/action-button/action-button.component.html